import { PaymentOffsetInterface } from "../PaymentOffsetInterface";
import { PaymentOffset } from "../PaymentOffset";
import Translator from "../../../../../Translation/Translator";

class Plus3Day extends PaymentOffset implements PaymentOffsetInterface  {

  public static value: number = 3;

  public getName(): string {
    return Translator.trans("payment-offset-plus-3-day");
  }

}

export { Plus3Day }
